import Growth from '../containers/Growth/Main';
import {GROWTH_URL} from '../containers/Growth/growthConstants';

export const GrowthRoutes = [
	{
		...Growth,
		path: `${GROWTH_URL}`,
		pathRegex: `${GROWTH_URL}/:project/:product?/:page?`,
		titleId: 'app.document.title.apps',
	},
];
